import React, { useEffect, useState } from "react";
import Header from "../Include/Header";
import Sidebar from "../Include/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getCategory } from "../../../Store/Store/StoreMaster/Category/Category";
import { getUnit } from "../../../Store/Store/StoreMaster/Unit/Unit";
import Footer from "../Include/Footer";
import { addItem } from "../../../Store/Store/Item/ManageItem";
import { getLocation } from "../../../Store/Store/StoreMaster/InventoryLocation/Location";
import { getScheduleMaster } from "../../../Store/prosafe/master/schedule/getSchedule";
import { getClassMaster } from "../../../Store/prosafe/master/class/getClass";
import { getMocMaster } from "../../../Store/prosafe/master/moc/getMoc";
import UnitModal from "../../../Components/Item/UnitModal";
import { addUnit } from "../../../Store/Store/StoreMaster/Unit/ManageUnit";
import { addCategory } from "../../../Store/Store/StoreMaster/Category/ManageCategory";
import CategoryModal from "../../../Components/Item/CategoryModal";
import { addLocation } from "../../../Store/Store/StoreMaster/InventoryLocation/ManageLocation";
import LocationModal from "../../../Components/Item/LocationModal";
import { getItemCompany } from "../../../Store/Store/StoreMaster/ItemCompany/getItemCompany";
import ItemForm from "../../../Components/Item/ItemForm";

const ManageItem = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = location.state;

  const [disable, setDisable] = useState(false);
  const [selectValue, setSelectValue] = useState("");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [modal, setModal] = useState({
    unit: false,
    category: false,
    location: false,
  });

  const [unit, setUnit] = useState({
    name: "",
    disable: "",
    error: "",
  });

  const [categoryDetails, setCategoryDetails] = useState({
    name: "",
    disable: "",
    error: "",
  });

  const [locationDetails, setLocationDetails] = useState({
    name: "",
    address: "",
    disable: "",
    error: {},
  });

  // Select options data
  const categoryData = useSelector((state) => state?.getCategory?.user?.data);
  const unitData = useSelector((state) => state?.getUnit?.user?.data);
  const locationData = useSelector((state) => state?.getLocation?.user?.data);
  const scheduleData = useSelector(
    (state) => state?.getScheduleMaster?.user?.data
  );
  const classData = useSelector((state) => state?.getClassMaster?.user?.data);
  const mocData = useSelector((state) => state?.getMocMaster?.user?.data);

  const openModal = (type) => setModal((prev) => ({ ...prev, [type]: true }));
  const closeModal = (type) => setModal((prev) => ({ ...prev, [type]: false }));

  const resetLocation = () =>
    setLocationDetails({ name: "", address: "", error: {}, disable: false });

  const resetUnit = () => setUnit({ name: "", error: "", disable: false });

  const resetCategory = () =>
    setCategoryDetails({ name: "", error: "", disable: false });

  const handleUnitSubmit = () => {
    if (!unit.name.trim()) {
      setUnit((prev) => ({ ...prev, error: "Please enter Unit name" }));
      return;
    }

    setUnit((prev) => ({ ...prev, disable: true }));
    const bodyFormData = new URLSearchParams();
    bodyFormData.append("name", unit.name.trim());

    dispatch(addUnit(bodyFormData))
      .then((res) => {
        if (res.payload.success === true) {
          dispatch(getUnit());
          closeModal("unit");
          resetUnit();
        }
        setUnit((prev) => ({ ...prev, disable: false }));
      })
      .catch((error) => {
        console.log(error, "Error");
        setUnit((prev) => ({ ...prev, disable: false }));
      })
      .finally(() => {
        setUnit((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleCategorySubmit = () => {
    if (!categoryDetails.name.trim()) {
      setCategoryDetails((prev) => ({
        ...prev,
        error: "Please enter Category name",
      }));
      return;
    }

    const formData = new URLSearchParams();
    formData.append("name", categoryDetails.name);

    setCategoryDetails((prev) => ({ ...prev, disable: true }));
    dispatch(addCategory(formData))
      .then((res) => {
        if (res.payload.success === true) {
          dispatch(getCategory());
          closeModal("category");
          resetCategory();
        }
        setCategoryDetails((prev) => ({ ...prev, disable: false }));
      })
      .catch((error) => {
        console.log(error, "Error");
        setCategoryDetails((prev) => ({ ...prev, disable: false }));
      })
      .finally(() => {
        setCategoryDetails((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleLocationSubmit = () => {
    const newErrors = {};

    if (!locationDetails.name.trim()) {
      newErrors.name = "Please enter name";
    }

    if (!locationDetails.address.trim()) {
      newErrors.address = "Please enter Address";
    }

    if (Object.keys(newErrors).length > 0) {
      setLocationDetails((prev) => ({ ...prev, error: newErrors }));
      return;
    }

    const formData = new URLSearchParams();
    formData.append("name", locationDetails.name);
    formData.append("address", locationDetails.address);

    setLocationDetails((prev) => ({ ...prev, error: {}, disable: true }));

    dispatch(addLocation(formData))
      .then((res) => {
        if (res?.payload?.success === true) {
          dispatch(getLocation());
          closeModal("location");
          resetLocation();
        }
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      })
      .catch((error) => {
        console.log(error, "Error");
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      })
      .finally(() => {
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      });
  };

  const generateOptions = (
    data,
    labelKey,
    valueKey = "_id",
    thicknessKey = null
  ) =>
    data?.map((item) => ({
      label: thicknessKey
        ? `${item[labelKey]}${item[thicknessKey] ? ` (${item[thicknessKey]})` : ""
        }`
        : item[labelKey],
      value: item[valueKey],
      thickness: thicknessKey ? item[thicknessKey] : null,
    }));

  // const generateOptions = (data, labelKey, valueKey = '_id', thicknessKey = null) => {
  //   const options = data?.map(item => ({
  //     label: thicknessKey ? `${item[labelKey]}${item[thicknessKey] ? ` (${item[thicknessKey]})` : ''}` : item[labelKey],
  //     value: item[valueKey],
  //     thickness: thicknessKey ? item[thicknessKey] : null
  //   })) || [];

  //   // Add default reset option at the top
  //   return [{ label: `-- Select ${labelKey.charAt(0).toUpperCase() + labelKey.slice(1)} --`, value: null }, ...options];
  // };

  const ItemCompanyData = useSelector(
    (state) => state?.getStoreItemCompany?.user?.data
  );

  const itemCompanyOption = generateOptions(ItemCompanyData, "name");
  const unitOption = generateOptions(unitData, "name");
  const catOptions = generateOptions(categoryData, "name");
  const locationOptions = generateOptions(locationData, "name");
  const scheduleOptions = generateOptions(
    scheduleData,
    "schedule",
    "_id",
    "thickness"
  );
  const classOptions = generateOptions(
    classData,
    "className",
    "_id",
    "thickness"
  );
  const mocOptions = generateOptions(mocData, "name");
  const itemSpecData = [
    { value: "seamless", label: "Seamless" },
    { value: "erw", label: "Erw" },
  ];

  useEffect(() => {
    if (location.state) {
      setSelectValue(location.state?.status);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await Promise.all([
          dispatch(getCategory()),
          dispatch(getUnit()),
          dispatch(
            getItemCompany({
              status: "true",
            })
          ),
          dispatch(getLocation()),
          dispatch(getScheduleMaster({ payload: {} })),
          dispatch(getClassMaster({ payload: {} })),
          dispatch(getMocMaster({ payload: {} })),
        ]);
      } catch (error) {
        console.error("Fetch error:", error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = (formData, statusValue) => {
    setDisable(true);
    const payload = {
      firm_id: localStorage.getItem("PAY_USER_FIRM_ID"),
      year_id: localStorage.getItem("PAY_USER_YEAR_ID"),
      name: formData.name,
      itemCompanyId: formData.itemCompanyId ? formData.itemCompanyId : null,
      unit: formData.unit,
      hsn_code: formData.hsn_code,
      gst_percentage: formData.gst_percentage === "" ? 0 : formData.gst_percentage,
      purchase_rate: formData.purchase_rate === "" ? 0 : formData.purchase_rate,
      sale_rate: formData.sale_rate === "" ? 0 : formData.sale_rate,
      reorder_quantity: formData.reorder_quantity === "" ? 0 : formData.reorder_quantity,
      category: formData.category,
      material_grade: formData.material_grade,
      detail: formData.detail,
      location: formData.in_location,
      mcode: formData.mcode,
      // scheduleId: formData.scheduleId || null,
      // classId: formData.classId || null,
      // mocId: formData.mocId || null,
      // item_extra_spec: formData.item_extra_spec || null,
      is_transform: formData.is_transform,
      transform_type: formData.transform_type,
      stock_uom_type: formData.stock_uom_type,
      allow_partial_issue: formData.allow_partial_issue,
      allow_recuts: formData.allow_recuts,
      track_wastage: formData.track_wastage,
    };

    if (formData.thickness) {
      payload.thickness = formData.thickness;
    }

    if (data?._id) {
      payload.id = data._id;
      payload.status = statusValue;
    }

    dispatch(addItem(payload))
      .then((res) => {
        if (res.payload.success === true) {
          navigate("/main-store/user/item-management");
        }
        setDisable(false);
      })
      .catch((error) => {
        setDisable(false);
      });
  };

  const handleOpen = () => setIsSidebarOpen(!isSidebarOpen);

  useEffect(() => {
    setTimeout(() => {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    }, 0);
  }, []);

  return (
    <>
      <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
        <Header handleOpen={handleOpen} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/main-store/user/dashboard">Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/main-store/user/item-management">
                        Item List
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                    <li className="breadcrumb-item active">
                      {data?._id ? "Edit" : "Add"} Item
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <ItemForm
              data={data}
              disable={disable}
              openModal={openModal}
              options={{
                itemCompanyOption,
                unitOption,
                catOptions,
                locationOptions,
                scheduleOptions,
                classOptions,
                mocOptions,
                itemSpecData,
                scheduleData,
                classData,
              }}
              onSubmit={handleSubmit}
            />

          </div>
          <Footer />
        </div>
      </div>



      <UnitModal
        show={modal.unit}
        onClose={() => {
          closeModal("unit");
          resetUnit();
        }}
        unit={unit.name}
        setUnit={(value) =>
          setUnit((prev) => ({ ...prev, name: value, error: "" }))
        }
        unitError={unit.error}
        onSubmit={handleUnitSubmit}
        disableSubmit={unit.disable}
      />

      <CategoryModal
        show={modal.category}
        onClose={() => {
          closeModal("category");
          resetCategory();
        }}
        category={categoryDetails.name}
        setCategory={(value) =>
          setCategoryDetails((prev) => ({ ...prev, name: value, error: "" }))
        }
        categoryError={categoryDetails.error}
        onSubmit={handleCategorySubmit}
        disableSubmit={categoryDetails.disable}
      />

      <LocationModal
        show={modal.location}
        onClose={() => {
          closeModal("location");
          resetLocation();
        }}
        location={locationDetails}
        setLocation={(field, value) =>
          setLocationDetails((p) => ({ ...p, [field]: value }))
        }
        locationError={locationDetails.error}
        onSubmit={handleLocationSubmit}
        disableSubmit={locationDetails.disable}
      />
    </>
  );
};

export default ManageItem;
